/** 2026-03-20 B + Adoption Profile Card Swiper initialization **/
function initAdoptionProfileSwipers() {
    const imageSwipers = document.querySelectorAll('.adoption-pet-image-swiper:not(.swiper-initialized)');
    
    imageSwipers.forEach((swiperEl) => {
        const container = swiperEl.closest('.adoption-pet-image');
        
        if (!container) return;
        
        // Prevent event bubbling so inner swiper buttons don't trigger outer link clicks if any
        const nextBtn = container.querySelector('.adoption-pet-image-button-next');
        const prevBtn = container.querySelector('.adoption-pet-image-button-prev');
        
        if (nextBtn) {
            nextBtn.addEventListener('click', (e) => e.preventDefault());
        }
        if (prevBtn) {
            prevBtn.addEventListener('click', (e) => e.preventDefault());
        }

        new Swiper(swiperEl, {
            slidesPerView: 1,
            spaceBetween: 0,
            nested: true,
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
            },
            observer: true,
            observeParents: true,
        });
    });
}

document.addEventListener('DOMContentLoaded', initAdoptionProfileSwipers);
// Also initialize when section rendering API is used (e.g. infinite scroll or tab change)
document.addEventListener('shopify:section:load', initAdoptionProfileSwipers);
/** 2026-03-20 E + Adoption Profile Card Swiper initialization **/
